import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as FileSaver from 'file-saver';
import { MyPromise } from '../interceptors/myPromise.service';

const FILESAPIURL = `${environment.baseEndpoint}/filesv2`;

@Injectable({
  providedIn: 'root',
})
export class FilesService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  getFiles(requirement, type) {
    return this.myPromise.to(this.http.get(`${FILESAPIURL}/${requirement}?type=${type}`));
  }

  deleteFileByUrl(url) {
    return this.myPromise.to(this.http.post(`${FILESAPIURL}/file/url`, { url }));
  }

  async downloadFile(url, nameDoc = 'doc', fileType = 'docx') {
    return new Promise(resolve => {
      this.http.get(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/octet-stream',
        }), responseType: 'blob' as 'json', observe: 'response' as 'body',
      }).subscribe((response: any) => {
        const blob = new Blob([response.body]);
        FileSaver.saveAs(blob, `${nameDoc}.${fileType}`);
        resolve(true);
      });
    });
  }
}
